


import { useEffect, useState, useRef } from "react";
import axios from "axios";
import './Admin.css';
import { getUserFromCookie } from '../../Javascript_Functions_to_export/Utils';
import { useNavigate } from "react-router-dom";

import Cookie from 'js-cookie';

import { useToast } from "../../CustomeHooks/useToast";
import DescriptionPopUp from "../DescriptionPopUp/DescriptionPopUp";

import Dialogue from "../Dialogue/Dialogue";

import { showLocalDateAndTime, getJobCategories } from '../../Javascript_Functions_to_export/Utils';

const Admin = () => {

    const whishIcon = "data:@file/png;base64,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";
    const OMT_Icon = "data:@file/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABGCAIAAAD+THXTAAAAAXNSR0IB2cksfwAAAAlwSFlzAAAWJQAAFiUBSVIk8AAADh5JREFUeJztWglUVXUa/3i8x+PxNvZVYhVENlNQyhBcEFdyPG5NommOa2lHLXJ0anDNmUxDnTpaSSmWo2ajmZZlKtlCLsj+3rvQMpmYooASIIrz+9/7gAu8JzxFmXE85zuc+/73f7/7/b79+1/oZjHdZ9T5EjyA1BGQ6oulN4slxp8lVmZ3cjy188W34HMPIDXhEeMsYWRms8QyeJ0ByQTdh5Bul0wY/AGkuwJJcm8ku4uQ6ltGxf8+JNM4zaaHjqE74f9/CamV45mnFgVUnMqFW7dRYS1/pD2bJDdL5Nc5ZR1nX2vwqDb4/84F4y+oyhBUrQ+sMfjUGZzrOVvxI9hfq/ep1gczMvjWcq5Y4RuRZpyxcp3TgkOVPrgF/W7o1nqxkfDIdU59u1YqtgGYav1Dp/apNq2g+VPpmck0ZhCFuFO4D00bSwe2disvfAxC10NEThDUpizb8+U5lDJTmTJTsXg27dxAAAZUzTkDj7osx+8ltlPBb1byF4oXZtg1XovXhesXZin+Mod+zDQPCXpqpT/hlZIbBnkt51yWE7B8Lm1cqlow3dbPgxyVNHIAfbh1zIiBpLUhRxuKi6CfsiJqDN7XixUw6TWD5uR+FycbUkgZYU9SX6rURdVxjiKPwnuVMPI7r5A9v1NpTUopqUAyUluThr9WSo1MlDLRuoxcbIk75mYWEpRazzGXFQclLq4X2wLPVX3kwim04sUuYIQXaIBBTi5ycpXTyhT35NESQQ4PJXHf9q8xeAEVsO1Yb4f9UgkjCNS9C1XoEmoNbuICADf++cRATyXbIOyUS3hUMtLImOhYl0tJJiGZNbsW1rU8dVHTlaKubTteI6R63nkYHl2PScMoZbbKwZZxdNNQ6gLHE4cSCo4lnjwYs+hPtHlNoJcT2fIKHhFLwA+58dSMcUwIKyuykrC7UGpJVgKgCpDq2V/FVX34ollyFS+0xIqRjYTmTuuCVyxb4JA63ztl3sNqBYMKSEkJ0tQFnssWOC1bqF2xQL1tnbLW4HUrSAzJD6LcUiKv47RX9aFD+9DrK8M9tGQvp+UL6Vx2FBYRFYjOGr3/VV3311JoT/pwiCW3Zso7tsO9Sh96sXBYNw+GBHikVuwCrvXFP3vWGvwE/sz+Brczh0JcVExckGAl/CzNGVrFkkpQRVFsycmnHW2NJjqQEVKp71GlD8EtENyhnlO0AanJ5Th4uRp8VzxHfo701Bg7ZwWlr/MDxzpR1LG0odfmH7LfmKqBKILPLJ9HFUXxuUeGIcBspSSR0OABIVgH2jdXeSNyhGeRbxBak0Yyy9trKLZvmNSaKeXxAVSlCxf21Oh9Mz96FHGIdUcFnT0ZCZfG2+tbFIZ2ZjzoQHc83tWWnh5j1S+CXnuReRTL1MU2fE5v4FUiRyacO4GenaK05XU5diBdKBz9YXosQo6pX0KrXk7S8jGwYJoMahKehZE/3R4BTUHiKX8Mc9CwzUgAry8F7CAhv8MgSG5QBzjHhBGcudkwamFdYuzmTSF7GW1YGTHqMbqUG8hnRZtmgccJ+nbcvYG+2jfUTkqgxN50viB55eJQyAftIhIOf/yMEx+HE0YQfJJP3EqYKK4Xw9nVg458PFvO+x7gHd4ZDeMw/pz0SlFkmK8xSudNlkOkdhZ9E3gg+vnscOCBWLve7v3+WpaajPYRgTFGBafMO0jcN4kaObPSuEGANOkPiQo5b7TBsdKfclK6aJhY/aOZqeHSsMP2NC3wIAJXpyj3b3tMwXsdfLXgWJyQQvC60tPhWl4v2Jm+NqAGTmsBJJFTClo8daALs7iUtm3s8f46gsuZex7+XXKEMncHahVMo399ls4XPunlzJIvLLNpTb9f82eFeZOdNYX4UqUeGcKjrHBwoCu72+0hKs17Mi1Vq+C9y0tDF/L7I21AhhvFmoLDQWobFqJILZl7ouCrlkASu1OxzTWD9sgHzkISe2m+72uLyVy65K2k5r5Ufro9CJBg1U+2+p78rA8ukI6RrPKOT4IfxoYzi7mq6VJBbyTuJXPVUD9S6Ja0qN8KksclshdBfRNH0hXDw8gcrLJxHvu3uCh5GVzt6JdTCbwMJgOp5bBjAhLC41CGg5L374GPEOpsVVEg38I1e/IGJ0OAIaG/NIOyDg5B4fJ1o3NnEjPSHFS8w3ip6OfT4y8UjkqKJQUfEme+iPnhuzgHObseGEVnc8eey5vo58Q2K2SUsV5dzTo35XW+fjw/lSkCUAdFo/PoV2dwbeec1mqJdajar3Y5QyxAgi6RfL/do2rVmLI2CiH7WYZzgAvtejfR2ZbeWx9WVjhy8UwSHKmrK53PH3WpaPD0sazZwcqW9f2njiEhp3/xgVeF7pHvDwxytDGmO93RUPC8ydlA+suFcT38jblh5XxkyG7iJrXZ6NHq6Ka1laSwuyEzQCgI4Ji+IX7dYiSrYDSmdQYN3nrN4IAgRmAcyPBBVMRH04BompBA53OHAdLj/ZhNgGpyEpXrYit1vVe/wPjIrGj4IE+hcxs/lCoLI6CRjPXBGpkx3Z07FQY8MAV8jPs6zlnO50wZHdrmzgJMpNBbT1MNQEV+CVRXdN0H9TYqOyaSNi53zNzphMpQrQuBHBW6PkXHByyZp3BWkquG3l7XMyaILud3R5W8kD8CRrPltf6vt5hbgvZsUgMG+h2h30M7q/96IJQCVotmq4WAQasFkIIYyARHdvWy53MDnKXwcBBMZLKxbgOSMBc0MPXOOxqPUih0x68sCZo5nuaMpbdW0BtLafJI8lSzRORoR/NnuEwcShfzeiICIcp3+2PsefMC7YXcaIiCcM/7PBCSWfGNHLjNn8TqJtaRKob0NZo0eTQcIUR4O5qMTat91A19w4WcSHEJaR+kVtNoPd/2I+e4KJifwCve2TAiOYnQNaOlQBvuJCcfJ0pb7jVnAqpNKPBcL7apMgSmpXoIxST4ITZN8P2L7cXch4HQms83Xg5Yj2P7OeXlgl6e9sykeGTfexGwp+BRYPjUGIbTTkaDH8XPcIsOcFrFEscmGZ6FAjUx+/P+PfwYAGTS8UMo69C49LTI9cv8Pts5eNY42rIa3sIaC8G/ka+mj2abYSj4LevomLLQiwRH+jG5sf63RfIaLkAopqf327rym300VFbUnw2RPCSoJsKbVV7QW6vtWUVqNx4RJBNHvhi21WhPygtCsw96vrmU0MvNHE1rUujDjZS9X1OW3QV1k/dym4YcqNYdVn6/V5u111F/xAmDoLDOfO9T+6y9zif22V/RBQq5Cwa8dEZxcq8Sm898Iq/lBy1hf61eDbRY/36fsjzX29xAfhuQGnOgzfViBz6aQ+ED0D2PRNtYqRr7I6HzYPFjUAlds3gdDQEWUc0aRybGmd+PMaFZw8W6BxXWeSYWRJFpx2vmgQ3m4lEpAAPDhSABsq0wCDcR72MseBpILIrJRb6pl7FFrmG9xIr5npGPjXF/iXWzR9pCaCo9FJtfFKWQNjsuC07LxE81qzmSRqgWQmqvDsR3JSKvM7HecC02iLU5Pg0wzPGxjNoLCT5wTa+o1amMVKS+plc3XovXLb2u0akEqhWTcY9tR8ZSC0Icr3+eVsym5bNo5RzjBf6aJNy6xV3Tj8xpubJqNr0yh8pOSZtGT9792vRnCyDxZ6IhDRTKU9vXV3XdLNrfeF3NH6k2nA7cBSs1JGitmG4U2wuN7C1I2ICdpjcYzKzzqfVmsarFUNPipNFk83o78dfoAx3xYdxM9BozaosMzjDcMAXvFpBavqD1Y/Vcy783m+U94fMzT7cGc9c+UYtU3j5IJu+yCbfYqTLPsTzXrTzHvTLXo1rngTAwDgUmjXl3Id0J8eKii7tSFDkwnHyV5KcmXxVF+9Anb0vQ+Dbr0DjxINMeeLdTnToADwhNdHlRfFwobV7lfD5/Wmn+xA2pVn4q+vVUDBpfmAttIeia3gljBX5CBYh74TMP6GZjDmhpz86GFB9GW/+OcagPsnDp6TBvO/o4Pbz4q7C1z9PUETRlOLMb7p7Y577pZVQFF8C7ootIS6Gzx6mpzWvF/N5CaiBAqtD1jw9nkK4W9caAdD47HJB2bw795iP/DYsx9jisWGDtr6HCYwN+yBoWpKFfvlZVG/yz9nUNdaHfi9ybOto7zqIdBklwPIhemp9cmjf+3TX2Pkoq+bZ/ha5veVFMWeGoc3mTunvQjjcjzhdMinSnoxkY16M2LlUMiSZ+yDNxlPtfASnIicI8KNSN0asLqbwwtuBw0OzRNKwnDYxkJ3vb/xF1oWDcqBjWAV0qHPrEEPrzdLJ0br03kJwFSGlLyJAZUJLpWFXkWaN3rdKFD4+hKUlUlhNSqYuK9KYdb4TCbhmv0qNB9OPp5K7OdHR3txrzp7mdBgmBXqHrkxBO77/Kvgs1nFFJoP64MEp9ji7m9vh3VnBkF9q2zg3J43JeQIA9rfmrZ5gXXSoazH/wbOLGn3/cfkTdEZLGKozJHCkhKYp2r6WGc1kJf8johoThr6YAFQU5UKQXRbgzN8O0P6gXuSvpqREsopp9lu5cK4kaCwWkv1LgWqtzFP1/g4QdmutCLpyJ+jU7rjRnyMX8xN/ORAgnfmdznkjsTZuXwar+Lf55oDMhNREnrecUwulHvbg+lsjYqQjnAsBCtQUe7EHw/HxqaKAD6b+0r2v1MU5E977UWvpiRIjQQBmcD6ZTcgIJX5PMP95pkFobjSezIS5BsLG2qCnqOrKF7QgurWenNrrsVrrv0K68A1jcut63vHs3/526wyCZk/XOW5u7CMnkIHgHElsY9CVWFr2rcxR5V6nzJXgA6QGk+4M6X4IHkB5Auj/oP/J7PzARYQHXAAAAAElFTkSuQmCC";


    const navigate = useNavigate();
    const toast = useToast();

    const [companyName, setCompanyName] = useState('');
    const [jobs, setJobs] = useState();
    const [logs, setLogs] = useState();

    const [subscribers, setSubscribers] = useState();
    const [candidateName, setCandidateName] = useState('');
    const [candidateNumber, setCandidateNumber] = useState('');

    const [applicantsNumber, setApplicantsNumber] = useState(0);
    const [candidatesnb, setCandidatesnb] = useState(0);
    const [companiesNumber, setCompaniesNumber] = useState(0);
    const [jobsNumber, setJobsNumber] = useState(0);
    const [isFetchingJobs, setIsFetchingJobs] = useState(false);

    useEffect(() => {
        
        setIsFetchingJobs(true);

        //setInterval(() => {
            //console.log("refreshed");

            //var x = document.getElementById("c"); 
            //x.play();

            //var a = new Audio("C:/Users/Admin/Downloads/s.mp3");
            //a.play();

            axios.get(`${process.env.REACT_APP_URL}/numbers`)
            .then(res => {

                if(res.data.status === "success") {
                    setApplicantsNumber(res.data.Applications);
                    setCandidatesnb(res.data.Candidates);
                    setCompaniesNumber(res.data.Employers);
                    setJobsNumber(res.data.Jobs);
                }
                else {
                    toast("error", res.data.message);
                    console.log("error", res.data);
                }
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {

            });


            //console.log("I am the admin");
            // fetch all inactive jobs to active the one I want. 

            // user navigate to this page manually (using url)
            //if(!document.cookie) {
            if(!Cookie.get('adminToken')) {
                //toast('warning', 'Please login first !');
                navigate('/login');
            }
            else {
                //if(getUserFromCookie(document.cookie).AccountType === 2) {   // Admin=2
                if(getUserFromCookie(Cookie.get('adminToken')).AccountType === 2) {   // Admin=2
                    
                    axios.get(`${process.env.REACT_APP_URL}/subscribers`)
                    .then((res) => {
                        //console.log(res.data);
                        setSubscribers(res.data);
                    })
                    .catch((err) => {

                    });

                    axios.get(`${process.env.REACT_APP_URL}/admin`)
                    .then((res) => {
                        setJobs(res.data);
                    })
                    .catch((err) => {

                    })
                    .finally(() => {
                        setIsFetchingJobs(false);
                    });

                    axios.get(`${process.env.REACT_APP_URL}/getLogs`)
                    .then((res) => {
                        setLogs(res.data);
                    })
                    .catch((err) => {

                    });

                }
                else {
                    navigate('/login');
                }
            }
        //}, 10000);


        setCategories(getJobCategories());


    }, []);
    const [categories, setCategories] = useState();



    axios.defaults.withCredentials = true;
    const activateJob = (_job) => {

        //console.log("id = ", _job.JobID);
        axios.put(`${process.env.REACT_APP_URL}/activate_job`, 
            { 
                jobID: _job.JobID,
                //CompanyEmail: getUserFromCookie(document.cookie).CompanyEmail
                CompanyEmail: getUserFromCookie(Cookie.get('adminToken')).CompanyEmail
            })
        .then(res => {
            //if(res.data.status === 'success') {
                alert(res.data.message);
                //navigate('/admin');
                //window.location.href = "http://localhost:300x/admin";
                window.location.href = process.env.REACT_APP_ORIGIN + "/admin";
            //}
            //else
                //toast("error", res.data.error);
        })
        .catch(err => {
            if(err.response.status === 401) {
                toast("error", err.response.data.message);
            }
        })
        .finally(() => {
            //setIsSaving(false);
        })
    }

    const deleteCVs = () => {
        // delete 1 month ago CVs programmatically from the /public/XXX path.
    }

    const changeStatus = (e, job) => {
        if(e && e.target)
            setJobs(jobs.map(j => j.JobID === job.JobID ?
                { ...j, isSel: e.target.checked } :
                j ));            
    }

    const [_form, setForm] = useState("");

    const activateSubscription = (index) => {
        if(!subscribers || !subscribers[index]) {
            toast("error", "no subscriber found");
            return;
        }

        axios.post(`${process.env.REACT_APP_URL}/activate_Subscription`, 
            { 
                subscriberID: subscribers[index].ID, 
                userName: subscribers[index].Username,
                planType: subscribers[index].PlanType,
                remainingMessages: subscribers[index].RemainingMessagesNb,
            })
        .then(res => {
            if(res.data.status.toLowerCase() === 'success') {
                window.location.href = process.env.REACT_APP_ORIGIN + "/admin";
            }
            else
                toast("error", res.data.message);
        })
        .catch(err => {
            //console.log("error", err);

            if(err.response.status === 401) {
                toast("error", err.response.data.message);
            }
        })
        .finally(() => {
            //setIsSaving(false);
        })


    }

    const activateSelJobs = () => {
        // axios.get(`${process.env.REACT_APP_URL}/pay_online`)
        // .then(res => {
        //     console.log(res);
        //     setForm(res.data);
        // })
        // .catch(e => {
        //     console.log(e);
        // })
        // return;

        // Check if all selected jobs came from the same company.[]
        if(!jobs || jobs.length === 0)
            return;

        var selectedJobs = jobs.filter(j => j.isSel === true);
        
        if(!selectedJobs || selectedJobs.length === 0) {
            toast("error", "selectedJobs.length === 0");
            return;
        }

        // if(selectedJobs && selectedJobs.length > 1 ) {
        //     toast("error", "Don't activate more than job at once !");
        //     return;
        // }

        var companyID = selectedJobs[0].ID;
        var companyEmail = selectedJobs[0].Email;

        var jobsFromOtherCompany = selectedJobs.filter(j => j.ID !== companyID);

        if(jobsFromOtherCompany && jobsFromOtherCompany.length > 0) {
            toast("error", "not all jobs are from the same company");
            return;
        }

        var jobsIDs = [];
        var jobsCategories = [];

        var jobsTitles = "";
        
        for (let i = 0; i < selectedJobs.length; i++) {
            jobsIDs.push("'" + selectedJobs[i].JobID + "'");
            jobsCategories.push(selectedJobs[i].JobCategory);
            //jobsTitles += "<li>" + selectedJobs[i].JobTitle + "</li>@@@";
            jobsTitles += '<li><a href="' + process.env.REACT_APP_ORIGIN + '/job/details/' + selectedJobs[i].JobID +'">' + 
                            selectedJobs[i].JobTitle + "</a></li>@@@";
        }

        jobsIDs = jobsIDs.join(",");

        //var jobsTitles = "<li>Test 1</li>@@@<li>Test 2</li>@@@";
        //var jobsIDs = '240';
        
        //console.log("jobsCategories=", jobsCategories);
        //return;
        // go to server
        //axios.put(`${process.env.REACT_APP_URL}/activate_job`, 
        axios.post(`${process.env.REACT_APP_URL}/activate_job`, 
            { 
                jobsIDs: jobsIDs, 
                jobsTitles : jobsTitles, 
                companyEmail: companyEmail,
                companyName: selectedJobs[0].CompanyName,
                jobsCategories: jobsCategories,
            }
            // ,{
            //     //https://medium.com/@stheodorejohn/managing-cookies-with-axios-simplifying-cookie-based-authentication-911e53c23c8a
            //     headers: { 
            //         'Cookie': 'sessionid=abcdef123456', 
            //         'content-Type': 'application/json',
            //         //"Accept": "/",
            //         "Cache-Control": "no-cache",
            //         //"Cookie": document.cookie
            //     }
            // }
        )
        .then(res => {
            //console.log("success");
            
            if(res.data.status.toLowerCase() === 'success') {
                //setJobs(jobs.filter(job => job.JobID !== selectedJobs[0].JobID));
                window.location.href = process.env.REACT_APP_ORIGIN + "/admin";
            }
            else
                toast("error", res.data.message);
        })
        .catch(err => {
            //console.log("error", err);

            if(err.response.status === 401) {
                toast("error", err.response.data.message);
            }
        })
        .finally(() => {
            //setIsSaving(false);
        })
    }
    
    const [openDialog, setOpenDialog] = useState(false);

    const notifyCandidate = useRef(false);
    const categoryItem = useRef(0);
    
    const showDialog = (e) => {
        //console.log('e.target = ', e.target.checked);   // e.target.value : did not work
        //setConfidential(e.target.checked);
        if(e && e.target && e.target.checked) {            
            setOpenDialog(true);
            notifyCandidate.current = true;
            if (typeof window != 'undefined' && window.document) {
                document.body.style.overflow = 'hidden';
            }
        }
    }

    const closeDialog = (pCloseDialog) => {
        setOpenDialog(false);
        notifyCandidate.current = false;
        // ref: https://medium.com/@nikhil_gupta/how-to-disable-background-scroll-when-a-modal-side-drawer-is-open-in-react-js-999653a8eebb 
        //if (typeof window != 'undefined' && window.document) {
            document.body.style.overflow = 'unset';
        //}
    }

    const setCategoryItem = (e) => {
        categoryItem.current = e.target.value;
    }

    //const phoneNumbers = "96176376652,&#13;96176376652,";
    //const phoneNumbers = "96176376652,&#13;&#10;96176376652,";
    const phoneNumbers = "96176376652,\r\n" +
                         "96176376652,\r\n" +
                         "96176376652,\r\n" +
                         "96176376652,";

    const test = () => {

    }

    const [showPopUp, setShowPopUp] = useState(false);
    const [jobDescription, setJobDescription] = useState("");
    
    const openPopup = (jobDescription) => {
        setShowPopUp(true);
        setJobDescription(jobDescription);

        if (typeof window != 'undefined' && window.document) {
            document.body.style.overflow = 'hidden';
        }
        //document.body.style.overflow = '';
        //alert(jobDescription);
    }

    const fnClosePopUp = () => {
        //alert("close pop up");
        if (typeof window != 'undefined' && window.document) {
            document.body.style.overflow = 'unset';
        }
        setShowPopUp(false);
        setJobDescription("");
    }
    

    return(
    <>

        {/* table numbers div*/}
        <div>
            <br/><br/>
            {/* <audio controls="controls" id="c">
                <source src="https://www.computerhope.com/jargon/m/example.mp3" />
            </audio> */}
            <table id="numbers123456" border="1">
                <thead>
                    <tr>
                        <th>Applicants</th>
                        <th>Companies</th>
                        <th>Candidates</th>
                        <th>Jobs</th>
                    </tr>
                </thead>
                
                <tbody>
                    <tr>
                        <td>{ applicantsNumber - 1 } +</td>
                        <td>{ companiesNumber - 1} +</td> 
                        <td>{ candidatesnb - 1 } +</td>
                        <td>{ jobsNumber - 1 } +</td>
                    </tr>
                </tbody>
            </table>
        </div>

        {/* <div style={{ 
            border: "solid 1px black",
            height: "50px",
            width: "200px",
            marginLeft: "30px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            gap: "30px",
            }}>
                <div>
                    Profile
                </div>
                <div style={{
                        color: "red",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                    }}>
                        <div style={{ 
                            border: "1px solid red",
                            borderRadius: "50%",
                            width: "5px",
                            height: "5px",
                            background: "red",
                            }}
                            className="red-circle">
                        </div>

                        <div id="fading-text" style={{ 
                            fontSize: "14px",
                        }}>
                            New
                        </div>
                </div>
        </div> */}

        {/* <div style={{ marginLeft: "30px", }}>
            <input type="checkbox" 
                   name="notifyMe"
                   className="notify-me" 
                   style={{ width: '20px', 
                            height: '20px', 
                            cursor: 'pointer'}}
                   checked= { notifyCandidate.current }
                   value={ notifyCandidate.current }
                   onChange={ showDialog }
                //    disabled= {true} 
                   />

            Notify me on <i style={{ color: "green", 
                                    //  border: "1px solid green", 
                                    //  backgroundColor: "green",
                                    //  color: "white",
                                    fontSize: "20px",
                                     margin: "0 2px", 
                                     padding: "2px",
                                     borderRadius: "3px",}}
                            className="fa fa-whatsapp" 
                            aria-hidden="true"></i> when a new job in 
                            
                            <select onChange={ setCategoryItem } value={ categoryItem.current }>
                                {
                                    categories && 
                                    Array.isArray(categories) &&
                                    categories.map((category, index) => {
                                        return(
                                            <option key={index} 
                                                    value={ category.Id }>
                                                        { category.Name }
                                            </option>                                        
                                        )
                                    })
                                }
                            </select>
                            category is posted (1$/month).
                            <br/><br/>
                        
                    Plan availablity: From 21 Feb 2025 to 21 Mar 2025 <br/><br/>

            <button type="button">Open Dialog (disabled)</button>
        </div> */}

        <div className="admin-container every-page-container">
            

        {/* <button onClick={ activateSelJobs }>Pay</button> */}
        {/* <form align="center" method="post" action="https://pay.sandbox.fasterpay.com/payment/form" name="fasterpay_payment_form" id="fasterpay_payment_form"><input type="hidden" name="description" value="Test order" /><input type="hidden" name="amount" value="1" /><input type="hidden" name="currency" value="USD" /><input type="hidden" name="merchant_order_id" value="1731943015385" /><input type="hidden" name="sign_version" value="v2" /><input type="hidden" name="success_url" value="http://localhost:3000/admin" /><input type="hidden" name="pingback_url" value="http://localhost:3000/admin" /><input type="hidden" name="api_key" value="t_a60494a9ef8646c842a1adb55e5f58" /><input type="hidden" name="hash" value="0c55deadd8e59f733e42836f941195a0d9e08ea4d65f1f78cd08cbc12f6f10d6" /><input type="Submit" value="Pay Now" id="fasterpay_submit"/></form> */}
            {
                Cookie.get('adminToken') && 
                getUserFromCookie(Cookie.get('adminToken')).AccountType === 2 &&

                <form>
                    <div className="subscribers-section">
                        <div className="left-side">
                            <div><font color="red"><u><b>Subscribers Section</b></u></font><br/><br/></div>
                            <div className="headers">
                                <div className='header1 desktop' style={{ width: '60px', }}>ID</div>
                                <div className='header1 desktop' style={{ width: '60px', }}>Type</div>

                                <div className="username-col">
                                    <div className='header1'>💰 Method</div>
                                </div>

                                <div className="username-col">
                                        <input name="subscriber-username"
                                                style={{ width: "190px" }}
                                                type="text"
                                                value={ candidateName }
                                                onChange={ (e) => setCandidateName(e.target.value) }
                                                placeholder="Username"/>
                                    
                                    <div className='header1'>Username</div>
                                </div>
                                
                                <div className="phonenumber-col" style={{ width: '80px', }}>
                                        <input name="subscriber-phone"
                                        type="text"
                                        value={ candidateNumber }
                                        onChange={ (e) => setCandidateNumber(e.target.value) }
                                        placeholder="Phone"/>
                                    
                                    <div className='header1'>Phone</div>
                                </div>

                                {/* <div className='header' style={{ width: '250px', }}>Subscription date (LT 24h)</div> */}
                                {/* <div className='header' style={{ width: '150px', }}>Plan Status</div> */}
                                {/* <div className='header1 action' style={{ width: '80px', }}>
                                    Action
                                </div> */}
                            </div>
                            {
                                !subscribers &&
                                <div className="loading-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="30" viewBox="0 0 512 512">
                                    <path fill="#c9c9c9" d="M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"/></svg>
                                </div>
                            }
                            {
                                subscribers &&
                                Array.isArray(subscribers) &&
                                subscribers.length > 0 &&
                                subscribers.filter(subscriber => subscriber.Username
                                            .toLowerCase()
                                            .indexOf(candidateName.toLowerCase()) >= 0)
                                            .filter(subscriber => subscriber.PhoneNumber
                                            .toLowerCase()
                                            .indexOf(candidateNumber.toLowerCase()) >= 0)
                                            .map((sub, index) => {
                                    return(
                                        <div key={ index } className='single-row'>

                                            <span className='value desktop' style={{ width: '60px', }}>
                                                { sub.ID }
                                            </span>
                                            <span className='value desktop' style={{ width: '60px', }}>
                                                { 
                                                    sub.PlanType == 1 ? 
                                                    <>
                                                        <font color="green" size="3"><b>
                                                        🥯
                                                        {/* 💰 🥯*/}
                                                        </b></font>
                                                    </>
                                                    : 
                                                    sub.PlanType == 2 ? 
                                                    <>
                                                        <font color="#1d901d" size="3"><b>
                                                        🥯🥯
                                                        </b></font>
                                                    </> :
                                                    <>
                                                        <font color="#1d901d" size="3"><b>
                                                        🥯🥯🥯
                                                        </b></font>
                                                    </>
                                                }
                                            </span>

                                            <span>
                                                { 
                                                    sub && 
                                                    sub.PaymentMethod &&
                                                    sub.PaymentMethod.trim().toLowerCase() === "omt" ? 
                                                    <img src={ OMT_Icon } 
                                                        alt="Whish"
                                                        style={{ width:"30px", height:"30px", borderRadius:"50%" }}  />
                                                    :
                                                    sub && 
                                                    sub.PaymentMethod &&
                                                    sub.PaymentMethod.trim().toLowerCase() === "wish" ? 
                                                    <img src={ whishIcon } 
                                                        alt="Whish"
                                                        style={{ width:"30px", height:"30px", borderRadius:"50%" }}  />
                                                    :
                                                    sub && 
                                                    sub.PaymentMethod &&
                                                    sub.PaymentMethod.trim().toLowerCase() === "card" ? 
                                                    <img src={ whishIcon } 
                                                        alt="Whish"
                                                        style={{ width:"30px", height:"30px", borderRadius:"50%" }}  />
                                                    :
                                                    "Something went wrong"
                                                }
                                            </span>

                                            <span className='value username' 
                                                style={{
                                                    height: '30px',
                                                    color: "red",
                                                    fontSize: "14px",
                                                    textWrap: "wrap",
                                                }}>
                                                <b>{ sub.Username }</b>
                                            </span>
                                            <span className='value phone' style={{ width: '80px', }}>
                                                { sub.PhoneNumber }
                                            </span>
                                            {/* <span className='value' style={{ width: '250px', }}>
                                                { sub && sub.Subs_Code_DateTime }
                                            </span> */}
                                            {/* <span className='value' style={{ width: '150px', }}>
                                                { 
                                                    sub && 
                                                    sub.PlanStatus == 1 ?
                                                    "In Review ..." : "Something went wrong"
                                                }
                                            </span> */}
                                            <span className='value action' style={{ width: '80px', }}>
                                                <button type="button"
                                                        className="activate-sub"
                                                        style={{ 
                                                            border: "none",
                                                            color: "white",
                                                            padding: "7px 10px",
                                                            borderRadius: "3px",
                                                            cursor: "pointer",
                                                            background: `${ 
                                                                sub && sub.PlanStatus == 1 ? 'red' : 
                                                                sub && sub.PlanStatus == 0 ? 'gray' : 
                                                                'green'
                                                            }`,
                                                        }}
                                                        onClick={ (e) => activateSubscription(index) }>
                                                    { 
                                                        sub && 
                                                        parseInt(sub.PlanStatus) === 1 ?
                                                        "Activate" : "Something went wrong"
                                                    }
                                                </button>
                                            </span>
                                            
                                        </div>
                                    )
                                })
                            }
                        </div>
                        {/* <div className="right-side">
                            <textarea value={ phoneNumbers } 
                                      cols="50" rows="10"
                                      onChange={ test }></textarea>
                        </div> */}
                    </div>

                    <br/>
                    
                    <div className="jobs-section" style={{border: "solid 1px red"}}>
                        Search for a Company Name : <br/><br/>

                        <button type="button"
                                className="btn-activate-job"
                                onClick={ activateSelJobs }>
                                Activate Selected Jobs
                        </button>&nbsp;&nbsp;
                        <input name="compamy-name"
                            type="text"
                            value={ companyName }
                            onChange={ (e) => setCompanyName(e.target.value) }
                            placeholder="Company Name"/>
                        <br/><br/>
                        <div><b><u>Jobs List to activate:</u></b></div><br/>

                        <div className="headers">
                            <span className='header' style={{ width: '50px', }}>Selection</span>
                            <span className='header' style={{ width: '80px', }}>Job ID</span>
                            <span className='header' style={{ width: '100px', }}>Username</span>
                            <span className='header' style={{ width: '210px', }}>Company Name</span>
                            <span className='header' style={{ width: '250px', }}>Email</span>
                            <span className='header' style={{ width: '300px', }}>Job Title</span>
                            <span className='header' style={{ width: '150px', }}>Posted date (LT 24h)</span> 
                            <span className='header' style={{ width: '110px', }}>Description</span>
                            {/* <span className='header' style={{ width: '110px', }}>Email to Send</span> */}
                            {/* <span className='header' style={{ width: '100px', }}>Action</span> */}
                        </div>
                        
                        <div className="all-jobs-list">
                            {
                                isFetchingJobs &&
                                <div className="isloading-jobs">
                                    Loading Jobs ...
                                </div>
                            }
                            {
                                !isFetchingJobs &&
                                jobs &&
                                Array.isArray(jobs) &&
                                jobs.length === 0 &&
                                <div className="isloading-jobs green">
                                    No jobs found
                                </div>
                            }
                            {
                                !isFetchingJobs &&
                                jobs &&
                                Array.isArray(jobs) &&
                                jobs.length > 0 &&
                                jobs.filter(job => job.CompanyName.toLowerCase().indexOf(companyName.toLowerCase()) >= 0).map((j, index) => {
                                    return(
                                        <div key={ index } className='single-row'>

                                            <span className='value' style={{ width: '50px', height: "30px" }}>
                                                <input type="checkbox"
                                                        style={{ width: '30px', 
                                                                height: '30px', 
                                                                cursor: 'pointer'}}
                                                        
                                                        checked= { j.checked }
                                                        value={ j.checked } 
                                                        onChange={ (e) => changeStatus(e, j) } />
                                            </span>

                                            <span className='value'>
                                                { j.JobID }
                                            </span>
                                            <span className='value' style={{ width: '200px', }}>
                                                { j.CompanyUsername }
                                            </span>
                                            <span className='value' style={{ width: '145px', }}>
                                                { j.CompanyName }
                                            </span>
                                            <span className='value' style={{ width: '250px', }}>
                                                { j.Email }
                                            </span>
                                            <span className='value' style={{ width: '250px', }}>
                                                <b><font color="red">{ j.JobTitle }</font></b>
                                            </span>
                                            <span className='value' style={{ width: '170px', }}>
                                                {/* { j.PostingDate } */}
                                                
                                                {
                                                    //showLocalDateAndTime(j).PostingDate
                                                    showLocalDateAndTime(j)
                                                    //j.PostingDate
                                                }

                                            </span>
                                            {/* <span className='value' style={{ width: '130px', }}>
                                                { j.EmailsToSent }
                                                { j.Active === 0 ? 'Inactive' : 'Active' }
                                            </span> */}

                                            <span style={{ 
                                                width: '50px', 
                                                display: "inline-flex",
                                                padding: "7px 0 7px 13px",
                                                }}
                                                className="see-span"
                                                onClick={ () => openPopup(j.JobDescription) }>
                                                <i className="fa fa-eye see-icon" aria-hidden="true"></i>
                                            </span>
                                            
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>

                    { 
                        showPopUp &&
                        <DescriptionPopUp jobDescription={ jobDescription } 
                                        fnClosePopUp={ fnClosePopUp } />
                    }
                    <br/>

                    <div style={{border: "solid 1px red"}}>
                        <h3>Logs (GMT date time)</h3>
                        <div className="logs-part">
                            {
                                logs &&
                                Array.isArray(logs) &&
                                logs.length > 0 &&
                                logs.map((log, index) => {
                                    return(
                                        <div key={ index }>
                                            <span className='value' style={{ width: '50px', textAlign: 'center' }}>
                                                { log.ID }
                                            </span>
                                            <span className='value' >
                                                { log.Message }
                                            </span>
                                            <span className='value' style={{ width: '230px', }}>
                                                { log.Date }
                                            </span>
                                            <span className='value' style={{ width: '200px', }}>
                                                { log.State }
                                            </span>
                                            <span className='value' style={{ width: '150px', }}>
                                                { log.ErrorNo }
                                            </span>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>

                    <br/><br/><br/>
                </form>
            }
        </div>
    </>)
}

export default Admin;






                                        // {
                                        //     !j.Active ?
                                        //     <span className='value' style={{ width: '100px',}}>
                                        //         <button name="activate" 
                                        //                 type="button" 
                                        //                 onClick={ () => activateJob(j) }>
                                        //             Activate
                                        //         </button>
                                        //     </span> :
                                        //     ''
                                        // }










